var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"PollMatrixResultsBar"},[_c('PollResultsChartBar',{attrs:{"chart-bar-data":_vm.chartData,"data-label-callback":_vm.dataLabel,"tooltip-label-callback":_vm.tooltipLabel,"stacked":"","max":_vm.max,"data-labels-anchor":"center","show-legend":"","data-labels-align":"center","hide-x":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }